export enum AssetTypeOld {
  Invalid = 0,
  Image = 1,
  Video = 2,
  Audio = 3,
  Font = 4,
  Document = 5,
  Code = 6,
  Subtitles = 7,
  Folder = 8,
  Model3D = 9,
}

// AI-prefixed mirror enum for CreativeAssetType
export enum AIAssetTypeOld {
  Invalid = 'Invalid',
  Image = 'Image',
  Video = 'Video',
  Audio = 'Audio',
  Font = 'Font',
  Document = 'Document',
  Code = 'Code',
  Subtitles = 'Subtitles',
  Model3D = 'Model3D',
  Folder = 'Folder',
}

export enum CreativeAssetPurposeOld {
  FullAd = 0,
  Logo = 1,
  Banner = 2,
  CtaButton = 3,
  Icon = 4,
  Background = 5,
  Other = 6,
}

export enum AiCreativeAssetPurposeOld {
  FullAd = 'Full Ad',
  Logo = 'Logo',
  Banner = 'Banner',
  CtaButton = 'CTA Button',
  Icon = 'Icon',
  Background = 'Background',
  Other = 'Other',
}
export enum AssetSource {
  TemplateAssets = 'TemplateAssets',
  BrandAssets = 'BrandAssets',
}

export enum AssetFolderEntityType {
  AssetsLibrary = 'AssetsLibrary',
  Creative = 'Creative',
  CreativeTemplate = 'CreativeTemplate',
  TemplateDynamicParameters = 'TemplateDynamicParameters',
  Brand = 'Brand',
  AiContentProject = 'AiContentProject',
  Widget = 'Widget',
}

export enum AssetType {
  Image = 0,
  Video = 1,
  Font = 2,
  AnimatedImage = 3,
  Audio = 4,
  Document = 5,
  Code = 6,
  Subtitles = 7,
  Model3D = 8,
  Other = 99,
}

export enum AiAssetType {
  Image = 'Image',
  Video = 'Video',
  Font = 'Font',
  AnimatedImage = 'Animated Image',
  Audio = 'Audio',
  Document = 'Document',
  Code = 'Code',
  Subtitles = 'Subtitles',
  Model3D = '3D Model',
  Other = 'Other',
}

export enum AssetPurpose {
  NA = 0,
  FullAd = 1,
  Logo = 2,
  Banner = 3,
  CtaButton = 4,
  Icon = 5,
  Background = 6,
  Other = 7,
}

export enum AiAssetContentState {
  NotRequested = 0,
  Requested = 1,
  InProgress = 2,
  CompletedSuccess = 3,
  CompletedError = 4,
}

export enum DerivedFilePurpose {
  HighQualityVideo = 0, // to be used in video template layers
  MidQualityVideo = 1, // to be used as ready to be served video in HTML ads and VPAID ads
  CompressedImage = 2,
  AnimatedImageAsImage = 3,
  AnimatedImageAsVideo = 4,
}
